import React, { createContext, useContext } from 'react';
import { SetValueConfig } from 'react-hook-form/dist/types/form';

type SetFieldValueProps = ((name: string, value: string, options: SetValueConfig) => void) | undefined;

type ApplyFormSetFieldValueProviderProps = {
  setFieldValue: SetFieldValueProps;
};

const SetFieldValueContext = createContext<SetFieldValueProps>(undefined);

export const ApplyFormSetFieldValueProvider: React.FC<ApplyFormSetFieldValueProviderProps> = ({
  setFieldValue,
  children,
}) => {
  return <SetFieldValueContext.Provider value={setFieldValue}>{children}</SetFieldValueContext.Provider>;
};

export const useSetFieldValue = (): SetFieldValueProps => {
  const setFieldValue = useContext(SetFieldValueContext);

  if (typeof setFieldValue === 'undefined') {
    throw new Error('setFieldValue must be used within an SetFieldValueContext');
  }

  return setFieldValue;
};
